<div class="container">
  <div class="error-message">
    <h2>Oops, something wrong happened</h2>
    <button type="button" class="button-outline" (click)="goBack()">Back</button>
  </div>
</div>
